import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../../api/generic/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const WoHMaterialTemplateType = SearchDataTableType({
	request: BaseRequest({
		sortFields: constants.wholeHouse.materialTemplate.sortFields,
		columnFields: constants.wholeHouse.materialTemplate.columnFields,
		standardFilterFields: constants.wholeHouse.materialTemplate.osStandardFilterFields,
		dateFilterFields: constants.wholeHouse.materialTemplate.osDateFilterFields,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	}),
	columnFields: constants.wholeHouse.materialTemplate.columnFields,
	filterIds: constants.wholeHouse.materialTemplate.filterFields,
});
